import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import * as actions from '../../actions';
import Membership from '../../components/Membership';
import openWithAppTalk from '../../utils/openWithAppTalk';
import {STATUS_NOT_REGISTERED} from '../../reducers/membership';
import MembershipAddFriend from "../../components/MembershipAddFriend";

export class MembershipPage extends Component {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
  }

  handleClose() {
    openWithAppTalk(this.props.device, 'web/close', 'kakaotalk');
  }

  render() {
    const { membership } = this.props;
    const status = membership.get('status');
    if (status === STATUS_NOT_REGISTERED) {
      return (
        <MembershipAddFriend {...this.props} onClose={this.handleClose}/>
      );
    }

    return (
      <Membership {...this.props} onClose={this.handleClose}/>
    );
  }
}

const mapStateToProps = (state, { match: { params: { encodedProfileId } } } ) => {
  const { device, membership, phase } = state;
  const profileId = encodedProfileId;
  return { profileId, device, membership, phase };
};

export default connect(
  mapStateToProps,
  (dispatch) => bindActionCreators({
    fetchMembership: actions.fetchMembership
  }, dispatch)
)(MembershipPage);


// WEBPACK FOOTER //
// ./src/containers/MembershipPage/index.js